<div class="cit-wrap">
  <div class="box-middle">
    <div class="columns" (click)="updateChildrenForChange(); isShowList = !isShowList">
      <div>
        <span>{{globals.child.name}}</span>
        <span class="icon-triangle-down" [hidden]="isAlone">▼</span>
        <!-- 아동 선택 목록 -->
        <ul class="list" *ngIf="!isAlone" [hidden]="!isShowList">
          <li *ngFor="let ch of childrenForChange; let i = index; let first = first" (click)="changeChild(ch)">
            <span>{{ch.name}}</span>
            <span class="icon-triangle-down" *ngIf="first">▼</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
